export default __webpack_public_path__ + "static/media/work.a73d6099.svg";